export default __webpack_public_path__ + "static/media/the-horror-zine-spring-2023.42956306.jpg";